import { LEFT } from 'constants/enums.constants';
import { STATUS_IDLE } from 'constants/statuses.constants';

export const getInitialState = () => ({
  activeStep: 0,
  activeSubstep: null,
  slideDirection: LEFT,
  saveStatus: STATUS_IDLE,
});
